export const CoreIcon = ({ useOriginalColor }) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 18.2553C15.007 18.2553 18.2553 15.007 18.2553 11C18.2553 6.993 15.007 3.74468 11 3.74468C6.993 3.74468 3.74468 6.993 3.74468 11C3.74468 15.007 6.993 18.2553 11 18.2553ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
      fill={useOriginalColor ? "#6C6CFF" : "currentColor"}
    />
    <path
      d="M14.4357 11.001C14.4357 12.8979 12.8979 14.4357 11.001 14.4357C9.10414 14.4357 7.56641 12.8979 7.56641 11.001C7.56641 9.10414 9.10414 7.56641 11.001 7.56641C12.8979 7.56641 14.4357 9.10414 14.4357 11.001Z"
      fill={useOriginalColor ? "#8F8FFF" : "currentColor"}
    />
  </svg>
);
